import { Button } from '@/components/ui/button';
import insightBanner from '@/assets/landing/images/insight-banner.png';
import { SCHEDULE_DEMO_URL } from '@/constants/externalLinks';

export default function InsightSection() {
  return (
    <section className="py-24 bg-white text-gray-900">
      <div className="landing-container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img src={insightBanner} alt="Insights que viraram conteúdos" className="w-full h-auto rounded-lg" />
          </div>
          <div className="space-y-8">
            <div className="flex items-center space-x-4">
              <span className="text-sm bg-gray-200 px-3 py-1 rounded-full text-gray-700">[Add-on]</span>
            </div>
            <h2 className="text-4xl font-bold leading-tight text-gray-900 font-['Times_New_Roman']">Do insight à execução criativa</h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Com os insights identificados pelo Culture Monitor, você pode contratar à parte os times criativos e de gestão de criadores da LIVE The Agency para transformar oportunidades culturais em ideias e campanhas executadas com rapidez, qualidade e impacto — com creators já mapeados e validados pela plataforma.
            </p>
            <p className="text-sm text-gray-500 italic">*Disponível como serviço adicional, de acordo com o plano contratado.</p>
            <Button asChild className="bg-black text-white hover:bg-gray-800 rounded-lg">
              <a
                href={SCHEDULE_DEMO_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-tracking-id="landing-schedule-demo-insight"
              >
                Agende uma apresentação
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

